import React, {lazy} from 'react'
import t from 'format-message'
import {useDocumentTitle} from '../common/lib/useDocumentTitle'
import {useParams} from 'react-router'

const Observe = lazy(() =>
  import('./components/pages/Observe').then(({Observe}) => ({default: Observe})),
)

export function ObservePage() {
  const {activeAssignmentId} = useParams()

  useDocumentTitle(t('Observe'))

  return <Observe activeAssignmentId={activeAssignmentId} app="observing" />
}

/**
 * @type {import('react-router').RouteObject[]}
 * @description The routes for the observing module.
 */
export const observingRoutes = [
  {
    index: true,
    element: <ObservePage />,
  },
]
